/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateMaterialDto = {
  /**
   * Material name
   */
  name?: string;
  /**
   * Material description
   */
  description?: string;
  /**
   * Source of creation
   */
  source?: UpdateMaterialDto.source;
};
export namespace UpdateMaterialDto {
  /**
   * Source of creation
   */
  export enum source {
    CATALOG = 'CATALOG',
    SETTINGS = 'SETTINGS',
  }
}
